import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { templateDictionary } from './request';
import { CHARTLIST, CARDLIST } from './utils';
export default {
  props: {
    customerId: {
      type: Number,
      default: 0
    }
  },
  watch: {
    dictionaryList: {
      handler() {}
    },
    deep: true
  },
  data() {
    return {
      visible: false,
      dictionaryList: [],
      showList: [],
      formData: {
        dictionariesId: []
      },
      itemObj: {},
      dictionaryShow: false
    };
  },
  computed: {
    formFules() {
      return {
        showForm: [{
          required: true,
          message: this.$t('请选择') + this.$t('展现形式'),
          trigger: 'change'
        }],
        dictionariesId: {
          required: true,
          validator: this.validateDictionariesId,
          trigger: 'change'
        }
      };
    }
  },
  methods: {
    validateDictionariesId(rule, value, callback) {
      if (!(value !== null && value !== void 0 && value.length)) {
        callback(new Error(this.$t('请选择') + this.$t('字典')));
      } else if (value.length > 6 && this.formData.showForm == 'SINGLE_CARD') {
        callback(new Error(this.$t('最多可选择六个')));
      } else {
        callback();
      }
    },
    async init(val) {
      this.showList = CHARTLIST;
      this.dictionaryShow = false;
      this.itemObj = val;
      if (val.dictionariesConfig == 'YES') {
        this.showList = CARDLIST;
        this.dictionaryList = await templateDictionary({
          customerId: this.customerId
        });
        this.dictionaryShow = true;
      }
      this.visible = true;
    },
    onChange(e, index, index2) {
      this.dictionaryList[index].children[index2].checked = e.target.checked;
      this.formData.dictionariesId = [];
      this.dictionaryList.map(item => {
        item.children.map(item2 => {
          if (item2.checked) {
            this.formData.dictionariesId.push(item2.value);
          }
        });
      });
      console.log(this.formData.dictionariesId);
    },
    handleSure() {
      this.$refs.dataFormRef.validate(valid => {
        if (valid) {
          if (this.formData.dictionariesId.length != 0) {
            let dictionaries = [],
              id = [];
            this.formData.dictionariesId.map(item => {
              let obj = {
                name: item.split(',')[1],
                id: item.split(',')[0]
              };
              id.push(obj.id);
              dictionaries.push(obj);
            });
            this.formData.dictionaries = dictionaries;
            this.formData.id = id;
          }
          this.$emit('ok', this.formData, this.itemObj);
          this.$emit('cancel');
        }
      });
    }
  }
};